import { useEffect, useState } from 'react';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import { getInvoicePdf } from './getInvoicePdf';
import type { InvoicePreview, InvoiceRequest } from './types';

export function useInvoicePreview(request: Readonly<InvoiceRequest>) {
  const { companyId, invoiceId } = request;
  const enabled = !!companyId && !!invoiceId;
  const key = BillingInvoiceHelper.invoiceUrl(request, 'preview');
  const [preview, setPreview] = useState<InvoicePreview>();

  useEffect(() => {
    setPreview(undefined);
    if (!enabled) return undefined;
    let active = true;
    let url: string | undefined;
    getInvoicePdf({ companyId, invoiceId })
      .then((pdf) => {
        if (!active) return;
        url = URL.createObjectURL(pdf);
        setPreview({ key, url });
      })
      .catch((error: unknown) => {
        if (active)
          setPreview({
            key,
            error:
              error instanceof Error
                ? error
                : new Error('Could not load the invoice PDF.'),
          });
      });
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [enabled, companyId, invoiceId, key]);

  const currentPreview = enabled && preview?.key === key ? preview : undefined;
  return {
    previewUrl: currentPreview?.url,
    error: currentPreview?.error,
    isLoading: enabled && !currentPreview,
  };
}
